<template>
    <footer class="footer" :style="{bottom: -height + 22 + 'px'} " ref='footer'>
        <p v-if="view < 2">
            By answering the questions, you agree to the data collection. <br>
            © 2020. ABCMobile OÜ <br>
            Harju maakond, Tallinn, Peterburi tee 71-318, 11415, Estonia. <br>
            Email: <a href="support@abcmobile.com">support@abcmobile.com</a> <br>
            See our <a href="./terms.php">Terms and Conditions</a>  and <a href="./privacy.php"> Privacy Policy</a> <br>
            Affiliate: mobstra.com
        </p>
        <p v-else>
            Calls cost <b>£3/call</b> + <b>£3/min</b>, calls recorded, for entertainment only 18+.<br>
            Customer care <a href="support@abcmobile.com">support@abcmobile.com</a> <br>
            © 2020. ABCMobile OÜ <br>
            Harju maakond, Tallinn, Peterburi tee 71-318, 11415, Estonia. <br>
            See our <a href="./terms.php">Terms and Conditions</a> and <a href="./privacy.php"> Privacy Policy</a> <br>
            Affiliate: mobstra.com
        </p>
    </footer>
</template>

<style lang="scss">
    .footer {
        font-size: 11px;
        position: absolute;
        text-align: center;
        color: #7B8B9E;
        left: 50%;
        transform: translate(-50%, 0);
        width: 100%;
        max-width: 350px;
        padding: 0 15px;
        background: #fff;
        @media (max-width: 320px) {
            min-width: 283px;
        }
    }
</style>

<script>
    export default {
        props:['view'],
        data:()=>({
            height: null
        }),
        computed:{
            call(){
                return this.view
            }
        },
        mounted(){
            this.height = this.$refs.footer.clientHeight
        },
        watch:{
            call: {
                handler: function(){
                    setTimeout(() => {
                        this.height = this.$refs.footer.clientHeight
                    })
                }
            }
        }

    }
</script>